import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.pad-start";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getOpMessageList, sendOpMessage } from '@/api/apis';
export default {
  name: 'MessageLog',
  data: function data() {
    return {
      loading: false,
      sendLoading: false,
      list: [],
      total: 0,
      sendVisible: false,
      isEdit: false,
      // 标识当前是否为编辑模式
      queryParams: {
        page: 1,
        limit: 20,
        where: {
          biz_type: 'order',
          status: 1
        }
      }
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    formatTimestamp: function formatTimestamp(timestamp) {
      if (!timestamp || timestamp === 0) return '-';
      var date = new Date(String(timestamp).length === 10 ? timestamp * 1000 : timestamp);
      var y = date.getFullYear();
      var m = (date.getMonth() + 1).toString().padStart(2, '0');
      var d = date.getDate().toString().padStart(2, '0');
      var h = date.getHours().toString().padStart(2, '0');
      var i = date.getMinutes().toString().padStart(2, '0');
      var s = date.getSeconds().toString().padStart(2, '0');
      return "".concat(y, "-").concat(m, "-").concat(d, " ").concat(h, ":").concat(i, ":").concat(s);
    },
    getList: function getList() {
      var res;
      return regeneratorRuntime.async(function getList$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              _context.next = 4;
              return regeneratorRuntime.awrap(getOpMessageList(this.queryParams));

            case 4:
              res = _context.sent;

              if (res) {
                this.list = res.rows || [];
                this.total = res.count || 0;
              }

              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              this.$message.error('获取列表失败');

            case 11:
              _context.prev = 11;
              this.loading = false;
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[1, 8, 11, 14]]);
    },
    handleQuery: function handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    resetQuery: function resetQuery() {
      this.queryParams.where = {
        biz_type: '',
        status: null
      };
      this.handleQuery();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getList();
    },
    handleView: function handleView(row) {
      this.$alert(row.content || '暂无详细内容', row.title || '消息详情');
    },
    // 打开新增窗口
    handleOpenSend: function handleOpenSend() {
      this.isEdit = false;
      this.resetSendForm();
      this.sendVisible = true;
    }
  }
};